import { LoginUserItem } from "@/types";
import diplomaCurve from "@/assets/svg/diploma-curve.svg";
import edusognoLogoCertified from "@/assets/svg/edusogno-logo-certified.svg";
import edusognoPartners from "@/assets/svg/edusogno-partners-diploma.svg";

interface DiplomaProps {
  english_course: string;
  start_month: string;
  english_level: string;
  course_duration: number;
  user?: LoginUserItem;
  type: string | null;
}

const PdfDiploma = ({
  english_course,
  start_month,
  english_level,
  course_duration,
  user,
  type,
}: DiplomaProps) => {
  const pot = type === "pot";
  const ielts = type === "ielts";
  const all = type === "all";
  return (
    <>
      {ielts && (
        <div>
          <div
            id="captureDiplomaPDF"
            className="bg-white text-edu-900 relative mx-auto px-5 font-sans flex flex-col justify-center items-center"
            style={{
              width: "297mm",
              height: "167.062mm",
            }}
          >
            <div className="max-w-[300px] max-h-[400px] absolute top-0 left-0">
              <img
                src={diplomaCurve}
                className="object-cover object-center w-full h-full block"
                alt=""
              />
            </div>
            <div className="max-w-[300px] max-h-[400px] absolute bottom-0 right-0 -rotate-180">
              <img
                src={diplomaCurve}
                className="object-cover object-center w-full h-full block"
                alt=""
              />
            </div>
            <div className="w-full h-full flex flex-col justify-evenly items-center text-center py-20">
              <div className="max-w-[187px]">
                <img
                  src={edusognoLogoCertified}
                  className="object-contain object-center w-full h-full block"
                  alt=""
                />
              </div>
              <div>
                <h1 className="text-5xl font-semibold mb-12">
                  {english_course}
                </h1>
                <p className="text-xl font-light leading-5">
                  <strong className="font-semibold">
                    {user?.first_name} {user?.last_name}
                  </strong>{" "}
                  successfully participated in the Edusogno English course with
                  native-speaking tutors
                </p>
                <p className="text-2xl font-semibold">{start_month}</p>
              </div>
              <div className="flex flex-row justify-between items-center gap-24">
                <div>
                  <span className="text-xl font-light">Level</span>
                  <p className="text-2xl font-semibold">{english_level}</p>
                </div>
                <div className="text-lg">
                  <span className="text-xl font-light">Course Duration</span>
                  <p className="text-2xl font-semibold">
                    {course_duration} hours
                  </p>
                </div>
              </div>
              <div className="flex flex-row justify-center items-center gap-x-8 mt-2">
                <p className="text-lg font-light">Edusogno partners</p>
                <div>
                  <img
                    src={edusognoPartners}
                    className="object-contain object-center w-full h-full block"
                    alt=""
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {(pot || all) && (
        <div>
          <div
            id="captureDiplomaPDF"
            className="bg-white text-edu-900 relative mx-auto px-5 font-sans flex flex-col justify-center items-center"
            style={{
              width: "297mm",
              height: "167.062mm",
            }}
          >
            <div className="max-w-[300px] max-h-[400px] absolute top-0 left-0">
              <img
                src={diplomaCurve}
                className="object-cover object-center w-full h-full block"
                alt=""
              />
            </div>
            <div className="max-w-[300px] max-h-[400px] absolute bottom-0 right-0 -rotate-180">
              <img
                src={diplomaCurve}
                className="object-cover object-center w-full h-full block"
                alt=""
              />
            </div>
            <div className="w-full h-full flex flex-col justify-evenly items-center text-center py-20">
              <div className="max-w-[187px]">
                <img
                  src={edusognoLogoCertified}
                  className="object-contain object-center w-full h-full block"
                  alt=""
                />
              </div>
              <div>
                <h1 className="text-5xl font-semibold mb-12">
                  {english_course}
                </h1>
                <p className="text-xl font-light leading-5">
                  <strong className="font-semibold">
                    {user?.first_name} {user?.last_name}
                  </strong>{" "}
                  successfully participated in the <br />
                  Edusogno English course with native-speaking tutors
                </p>
                <p className="text-xl">{start_month}</p>
              </div>
              <div className="flex flex-row justify-between items-center gap-24">
                <div>
                  <span className="text-xl font-light">Level</span>
                  <p className="text-2xl font-semibold">{english_level}</p>
                </div>
                <div>
                  <span className="text-xl font-light">Course Duration</span>
                  <p className="text-2xl font-semibold">
                    {course_duration} hours
                  </p>
                </div>
              </div>
              <div className="flex flex-row justify-center items-center gap-x-10 mt-6">
                <p className="text-lg font-semibold">Edusogno partners</p>
                <div className="max-w-full">
                  <img
                    src={edusognoPartners}
                    className="object-contain object-center w-full h-full block"
                    alt=""
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default PdfDiploma;
